import { motion } from "framer-motion";
import { MaskLines } from "./Reveal";

export const PageHero = ({ eyebrow, lines, sub, testId }) => (
  <section data-testid={testId} className="relative overflow-hidden bg-[#0E2657] pb-20 pt-40 sm:pb-28 sm:pt-48 grain">
    <div className="grid-lines absolute inset-0 [mask-image:linear-gradient(to_bottom,black,transparent)]" />
    <div className="absolute -right-40 top-10 h-[480px] w-[480px] rounded-full bg-[#29C1D3]/15 blur-[120px]" />
    <div className="container-x relative">
      <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="eyebrow text-cyan-400">
        {eyebrow}
      </motion.p>
      <MaskLines
        onLoad
        as="h1"
        lines={lines}
        className="mt-6 max-w-5xl font-display text-[2.75rem] font-bold leading-[1] tracking-tight text-white sm:text-6xl lg:text-7xl"
      />
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className="mt-8 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg"
      >
        {sub}
      </motion.p>
    </div>
  </section>
);
